export default __webpack_public_path__ + "a67cf12e743baae99486642640a43854.png";